"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.agent.speaking': 'Agent mówi',
    'conversation.agent.thinking': 'Agent myśli...',
    'conversation.agent.demo': 'Demo Agenta Głosowego',
    'conversation.agent.demo.description': 'Interaktywna rozmowa głosowa z agentami AI wykorzystująca zaawansowane rozpoznawanie i syntezę mowy',
};
